/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------

import axios, { AxiosRequestConfig, AxiosPromise, AxiosInstance } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

interface ClientApiConfig {
    baseUrl: string;
    axios: AxiosInstance;
}

export const BASE_URL_TOKEN_ConfigurationManagementApi = symbolToken<string>('BASE_URL_TOKEN', false);
export const AXIOS_TOKEN_ConfigurationManagementApi = symbolToken<string>('AXIOS_TOKEN', false);

@injectable()
export class ConfigurationManagementApi {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;
    protected readonly opts: ClientApiConfig;

    constructor(
        @inject(BASE_URL_TOKEN_ConfigurationManagementApi) @optional() baseUrl = '',
        @inject(AXIOS_TOKEN_ConfigurationManagementApi) @optional() axiosInstance = axios,
    ) {

        this.opts = {
            baseUrl,
            axios: axiosInstance,
        };
    }

    /**
     * @return Success
     */
    tenantSmsConfigurationGET(x_TenantId: any, x_PartnerId: any, signal?: AbortSignal): AxiosPromise<SmsConfiguration> {
        let url_ = "/api/ConfigurationManagement/TenantSmsConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            url: url_,
            method: "GET",
            headers: {
                "X-TenantId": x_TenantId !== undefined && x_TenantId !== null ? "" + x_TenantId : "",
                "X-PartnerId": x_PartnerId !== undefined && x_PartnerId !== null ? "" + x_PartnerId : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.opts.axios.request<SmsConfiguration>(options_);
    }

    /**
     * @body (optional) 
     * @return Success
     */
    tenantSmsConfigurationPOST(x_TenantId: any, x_PartnerId: any, body: UpdateSmsConfigurationRequest | undefined, signal?: AbortSignal): AxiosPromise<SmsConfiguration> {
        let url_ = "/api/ConfigurationManagement/TenantSmsConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            signal,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "X-TenantId": x_TenantId !== undefined && x_TenantId !== null ? "" + x_TenantId : "",
                "X-PartnerId": x_PartnerId !== undefined && x_PartnerId !== null ? "" + x_PartnerId : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.opts.axios.request<SmsConfiguration>(options_);
    }
}

export class SmsConfiguration implements ISmsConfiguration {
    customMarketingSmsOptInMessage!: string | null;
    marketingTcrCampaignCallToActionMessageId!: number | null;
    marketingTcrCampaignHelpMessageId!: number | null;
    marketingTcrCampaignMessageFlowId!: number | null;
    marketingTcrCampaignOptInConfirmationMessageId!: number | null;
    marketingTcrCampaignOptInMessageId!: number | null;
    marketingTcrCampaignOptOutMessageId!: number | null;

    constructor(data?: ISmsConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customMarketingSmsOptInMessage = _data["customMarketingSmsOptInMessage"] !== undefined ? _data["customMarketingSmsOptInMessage"] : <any>null;
            this.marketingTcrCampaignCallToActionMessageId = _data["marketingTcrCampaignCallToActionMessageId"] !== undefined ? _data["marketingTcrCampaignCallToActionMessageId"] : <any>null;
            this.marketingTcrCampaignHelpMessageId = _data["marketingTcrCampaignHelpMessageId"] !== undefined ? _data["marketingTcrCampaignHelpMessageId"] : <any>null;
            this.marketingTcrCampaignMessageFlowId = _data["marketingTcrCampaignMessageFlowId"] !== undefined ? _data["marketingTcrCampaignMessageFlowId"] : <any>null;
            this.marketingTcrCampaignOptInConfirmationMessageId = _data["marketingTcrCampaignOptInConfirmationMessageId"] !== undefined ? _data["marketingTcrCampaignOptInConfirmationMessageId"] : <any>null;
            this.marketingTcrCampaignOptInMessageId = _data["marketingTcrCampaignOptInMessageId"] !== undefined ? _data["marketingTcrCampaignOptInMessageId"] : <any>null;
            this.marketingTcrCampaignOptOutMessageId = _data["marketingTcrCampaignOptOutMessageId"] !== undefined ? _data["marketingTcrCampaignOptOutMessageId"] : <any>null;
        }
    }

    static fromJS(data: any): SmsConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new SmsConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customMarketingSmsOptInMessage"] = this.customMarketingSmsOptInMessage !== undefined ? this.customMarketingSmsOptInMessage : <any>null;
        data["marketingTcrCampaignCallToActionMessageId"] = this.marketingTcrCampaignCallToActionMessageId !== undefined ? this.marketingTcrCampaignCallToActionMessageId : <any>null;
        data["marketingTcrCampaignHelpMessageId"] = this.marketingTcrCampaignHelpMessageId !== undefined ? this.marketingTcrCampaignHelpMessageId : <any>null;
        data["marketingTcrCampaignMessageFlowId"] = this.marketingTcrCampaignMessageFlowId !== undefined ? this.marketingTcrCampaignMessageFlowId : <any>null;
        data["marketingTcrCampaignOptInConfirmationMessageId"] = this.marketingTcrCampaignOptInConfirmationMessageId !== undefined ? this.marketingTcrCampaignOptInConfirmationMessageId : <any>null;
        data["marketingTcrCampaignOptInMessageId"] = this.marketingTcrCampaignOptInMessageId !== undefined ? this.marketingTcrCampaignOptInMessageId : <any>null;
        data["marketingTcrCampaignOptOutMessageId"] = this.marketingTcrCampaignOptOutMessageId !== undefined ? this.marketingTcrCampaignOptOutMessageId : <any>null;
        return data;
    }
}

export interface ISmsConfiguration {
    customMarketingSmsOptInMessage: string | null;
    marketingTcrCampaignCallToActionMessageId: number | null;
    marketingTcrCampaignHelpMessageId: number | null;
    marketingTcrCampaignMessageFlowId: number | null;
    marketingTcrCampaignOptInConfirmationMessageId: number | null;
    marketingTcrCampaignOptInMessageId: number | null;
    marketingTcrCampaignOptOutMessageId: number | null;
}

export class UpdateSmsConfigurationRequest implements IUpdateSmsConfigurationRequest {
    customMarketingSmsOptInMessage!: string | null;
    marketingTcrCampaignCallToActionMessageId!: number | null;
    marketingTcrCampaignHelpMessageId!: number | null;
    marketingTcrCampaignMessageFlowId!: number | null;
    marketingTcrCampaignOptInConfirmationMessageId!: number | null;
    marketingTcrCampaignOptInMessageId!: number | null;
    marketingTcrCampaignOptOutMessageId!: number | null;

    constructor(data?: IUpdateSmsConfigurationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customMarketingSmsOptInMessage = _data["customMarketingSmsOptInMessage"] !== undefined ? _data["customMarketingSmsOptInMessage"] : <any>null;
            this.marketingTcrCampaignCallToActionMessageId = _data["marketingTcrCampaignCallToActionMessageId"] !== undefined ? _data["marketingTcrCampaignCallToActionMessageId"] : <any>null;
            this.marketingTcrCampaignHelpMessageId = _data["marketingTcrCampaignHelpMessageId"] !== undefined ? _data["marketingTcrCampaignHelpMessageId"] : <any>null;
            this.marketingTcrCampaignMessageFlowId = _data["marketingTcrCampaignMessageFlowId"] !== undefined ? _data["marketingTcrCampaignMessageFlowId"] : <any>null;
            this.marketingTcrCampaignOptInConfirmationMessageId = _data["marketingTcrCampaignOptInConfirmationMessageId"] !== undefined ? _data["marketingTcrCampaignOptInConfirmationMessageId"] : <any>null;
            this.marketingTcrCampaignOptInMessageId = _data["marketingTcrCampaignOptInMessageId"] !== undefined ? _data["marketingTcrCampaignOptInMessageId"] : <any>null;
            this.marketingTcrCampaignOptOutMessageId = _data["marketingTcrCampaignOptOutMessageId"] !== undefined ? _data["marketingTcrCampaignOptOutMessageId"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateSmsConfigurationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSmsConfigurationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customMarketingSmsOptInMessage"] = this.customMarketingSmsOptInMessage !== undefined ? this.customMarketingSmsOptInMessage : <any>null;
        data["marketingTcrCampaignCallToActionMessageId"] = this.marketingTcrCampaignCallToActionMessageId !== undefined ? this.marketingTcrCampaignCallToActionMessageId : <any>null;
        data["marketingTcrCampaignHelpMessageId"] = this.marketingTcrCampaignHelpMessageId !== undefined ? this.marketingTcrCampaignHelpMessageId : <any>null;
        data["marketingTcrCampaignMessageFlowId"] = this.marketingTcrCampaignMessageFlowId !== undefined ? this.marketingTcrCampaignMessageFlowId : <any>null;
        data["marketingTcrCampaignOptInConfirmationMessageId"] = this.marketingTcrCampaignOptInConfirmationMessageId !== undefined ? this.marketingTcrCampaignOptInConfirmationMessageId : <any>null;
        data["marketingTcrCampaignOptInMessageId"] = this.marketingTcrCampaignOptInMessageId !== undefined ? this.marketingTcrCampaignOptInMessageId : <any>null;
        data["marketingTcrCampaignOptOutMessageId"] = this.marketingTcrCampaignOptOutMessageId !== undefined ? this.marketingTcrCampaignOptOutMessageId : <any>null;
        return data;
    }
}

export interface IUpdateSmsConfigurationRequest {
    customMarketingSmsOptInMessage: string | null;
    marketingTcrCampaignCallToActionMessageId: number | null;
    marketingTcrCampaignHelpMessageId: number | null;
    marketingTcrCampaignMessageFlowId: number | null;
    marketingTcrCampaignOptInConfirmationMessageId: number | null;
    marketingTcrCampaignOptInMessageId: number | null;
    marketingTcrCampaignOptOutMessageId: number | null;
}